import React, { useEffect } from 'react';
import DoctorCard from '../DoctorCard';
import { doctors } from '../../data/doctors';
import { useLanguage } from '../../context/LanguageContext';
import PageHero from '../PageHero';
import { Award, Users } from 'lucide-react';
import { motion } from 'framer-motion';

const Doctors = () => {
  const { t, language } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const stat1Title = language === 'mr' ? '२५+ वर्षांचा अनुभव' : (language === 'kn' ? '೨೫+ ವರ್ಷಗಳ ಅನುಭವ' : '25+ Years Experience');
  const stat1Desc = language === 'mr' ? 'अग्रगण्य नेत्रशल्यचिकित्सक' : (language === 'kn' ? 'ಪರಿಣಿತ ನೇತ್ರ ತಜ್ಞರು' : 'Senior Ophthalmic Surgeons');
  const stat2Title = language === 'mr' ? '५०,०००+ समाधानी रुग्ण' : (language === 'kn' ? '೫೦,೦೦೦+ ಸಂತೃಪ್ತ ರೋಗಿಗಳು' : '50,000+ Happy Patients');
  const stat2Desc = language === 'mr' ? 'अचूक निदान व सुरक्षित शस्त्रक्रिया' : (language === 'kn' ? 'ನಿಖರ ರೋಗನಿರ್ಣಯ ಮತ್ತು ಶಸ್ತ್ರಚಿಕಿತ್ಸೆ' : 'Safe Microsurgeries & Accurate Care');

  return (
    <div className="bg-[#F8FAFC] min-h-screen">
      {/* Attractive Hero Banner matching Branches.js */}
      <PageHero
        badge={t('doctorsSection.badge')}
        title={t('doctorsSection.title')}
        subtitle={t('doctorsSection.pageSubtitle')}
      />

      {/* Main Content */}
      <div className="container mx-auto px-4 lg:px-8 -mt-16 relative z-20 pb-24">
        {/* Stats Row */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 mb-16 flex flex-col md:flex-row justify-center gap-8 md:gap-24 hover:border-gray-300 transition-colors max-w-4xl mx-auto"
        >
          <div className="flex items-center space-x-4">
            <div className="w-14 h-14 bg-white border border-gray-100 text-clinical rounded-full flex items-center justify-center shadow-sm">
              <Award size={24} strokeWidth={1.5} />
            </div>
            <div>
              <h4 className="text-navy font-bold text-xl">{stat1Title}</h4>
              <p className="text-gray-500 text-sm">{stat1Desc}</p>
            </div>
          </div>
          <div className="hidden md:block w-px h-14 bg-gray-200"></div>
          <div className="flex items-center space-x-4">
            <div className="w-14 h-14 bg-white border border-gray-100 text-clinical rounded-full flex items-center justify-center shadow-sm">
              <Users size={24} strokeWidth={1.5} />
            </div>
            <div>
              <h4 className="text-navy font-bold text-xl">{stat2Title}</h4>
              <p className="text-gray-500 text-sm">{stat2Desc}</p>
            </div>
          </div>
        </motion.div>

        {/* Doctors Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-5xl mx-auto">
          {doctors.map((doctor, index) => (
            <DoctorCard key={doctor.id} doctor={doctor} index={index} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Doctors;
